/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import * as OnboardingActions from 'actions/OnboardingActions';
import * as analytics from 'analytics/Analytics';
import notifications from 'notifications';
import EmailInvite from 'start/EmailInvite';
import {ButtonSize} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';

interface Props {
  onRequestClose: (...args: Array<any>) => any;
  copy: React.ReactNode;
}

class InviteUserModal extends React.Component<Props> {
  componentDidMount(): void {
    analytics.track('onboarding', 'viewed_invite_users_modal');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  inviteMembers = (emails: any, recaptcha: any) => {
    if (emails.length === 0) {
      notifications.error('Please specify an email address to invite.');
      return;
    }

    OnboardingActions.inviteUsers({emails, recaptcha});
    analytics.track('onboarding', 'invite_users', {
      count: emails.length,
      source: 'invite-user-modal',
    });
    this.props.onRequestClose();
  };

  render(): JSX.Element {
    return (
      <Modal
        onRequestClose={this.props.onRequestClose}
        title="Thanks for being a great Benchling user!"
        wrapInForm={false}
      >
        <div>
          {this.props.copy}
          <EmailInvite
            onInvite={this.inviteMembers}
            buttonSize={ButtonSize.SMALL}
            emailChipSize={TagsInputSize.SMALL}
          />
        </div>
      </Modal>
    );
  }
}

export default InviteUserModal;
